import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

type TStore = {
  id:number,
  name: string,
  uid: string,
  alias: string,
  created_at: string,
  is_default:boolean
}
type TStoreContext = {
  list: TStore[],
  current: TStore,
  showModal: boolean
}
const initialState:TStoreContext =  {
  list:[],
  current:{
    name: '',
    uid: '',
    alias: '',
    created_at: '',
    id: 0,
    is_default:false
  },
  showModal:false
}
interface StoreContextType {
  store: TStoreContext;
  updateStore: (newConfig: Partial<TStoreContext>) => void;
}
interface StoreProviderProps {
  children: ReactNode;
}

const StoreContext = createContext<StoreContextType>({store:initialState,updateStore:()=>{}});

export const StoreProvider:React.FC<StoreProviderProps> = ({ children }) => {
  const [store, setStore] = useState(initialState);
  const updateStore = useCallback((newConfig:Partial<TStoreContext>) => {
    setStore((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);
  
  const contextValue = useMemo(() => ({
    store,
    updateStore,
  }), [store, updateStore]);

  return (
    <StoreContext.Provider value={contextValue}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  return useContext(StoreContext);
};